import { Routes, Route } from "react-router-dom";
import AdminLogin from "../admin/pages/AdminLogin";
import AdminDashboard from "../admin/pages/AdminDashboard";
import AdminLayout from "../admin/layout/AdminLayout";
import DonationOverview from "../admin/pages/DonationOverview";
import Donors from "../admin/pages/Donors";
import AddCampaign from "../admin/pages/AddCampaign";
import CampaignList from "../admin/pages/CampaignList";
import AddUser from "../admin/pages/AddUser";
import UserList from "../admin/pages/UserList";
import MyAccount from "../admin/pages/setting/MyAccount";
import UserData from "../admin/pages/setting/UserData";
import BlogPreview from "../admin/pages/blogs/BlogPreview";
import AddBlog from "../admin/pages/blogs/AddBlog";
import BlogList from "../admin/pages/blogs/BlogList";
import AddVideo from "../admin/pages/galleries/AddVideo";

import AddImage from "../admin/pages/galleries/AddImage";
import Library from "../admin/pages/galleries/Library";
import AdminVolunteerList from "../admin/pages/AdminVolunteerList";
import AdminContactList from "../admin/pages/AdminContactList";
import ManageTeam from "../admin/pages/ManageTeam";
import ManageDocs from "../admin/ManageDocs";
import ManageContact from "../admin/pages/ManageContact";
import ManageStats from "../admin/pages/ManageStats";

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Base route: /n-jio-sevaa -> Login Page (Bina Sidebar ke) */}
      <Route path="/" element={<AdminLogin />} />

      {/* Nested routes: /n-jio-sevaa/dashboard -> Layout ke andar */}
      <Route element={<AdminLayout/>}>
        <Route path="dashboard" element={<AdminDashboard />} />

        <Route path="campaigns/create" element={<AddCampaign />} />
        <Route path="campaigns/live" element={<CampaignList />} />


        <Route path="blogs/create" element={<AddBlog />} />
        <Route path="blogs/all" element={<BlogList />} />
        <Route path="blogs/preview/:id" element={<BlogPreview />} />

        <Route path="donations/overview" element={<DonationOverview />} />
        <Route path="donations/donors" element={<Donors />} />


        <Route path="galleries/video" element={<AddVideo />} />
        <Route path="galleries/images" element={<AddImage />} />
        <Route path="galleries/library" element={<Library />} />


        <Route path="users/new" element={<AddUser />} />
        <Route path="users/list" element={<UserList />} />


        <Route path="volunteers-list" element={<AdminVolunteerList />} />
        <Route path="messages" element={<AdminContactList />} />


        <Route path="settings/site-settings" element={<ManageContact />} />
        <Route path="settings/stats" element={<ManageStats />} />
        <Route path="settings/account" element={<MyAccount />} />
        <Route path="settings/data" element={<UserData/>} />


        <Route path="team" element={<ManageTeam />} />
        <Route path="documents" element={<ManageDocs />} />


        {/* Future routes jaise: <Route path="donations" element={<ManageDonations />} /> */}
      </Route>
    </Routes>
  );
};

export default AdminRoutes;